import { Action } from 'store/store';
import { WidgetType } from 'widgets/WidgetType';
import { WidgetTypeActionPayload, WidgetActionType } from '../actions';
import { AnyAction } from 'redux';

export interface WidgetSetComponentPayload<T> extends WidgetTypeActionPayload {
    componentDelta: Partial<T>;
}

export type WidgetSetComponentAction<T> = Action<
    WidgetActionType.WIDGET_SET_COMPONENT_STATE,
    WidgetSetComponentPayload<T>
>;

export function createUpdateWidgetComponentStateAction<T>(
    widgetType: WidgetType
) {
    return (
        widgetKey: string,
        componentDelta: Partial<T>
    ): WidgetSetComponentAction<T> => {
        if (!widgetType || !widgetKey) {
            throw new Error('No widget type or widget key received');
        }
        return {
            type: WidgetActionType.WIDGET_SET_COMPONENT_STATE,
            payload: { widgetType, widgetKey, componentDelta },
        };
    };
}

export function isSetWidgetComponentStateAction(
    action: AnyAction
): action is WidgetSetComponentAction<unknown> {
    return action.type === WidgetActionType.WIDGET_SET_COMPONENT_STATE;
}
